// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2uN2x","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1SXMd"};